/**
 * App-level UI bridge for cross-cutting notifications raised from non-component
 * contexts (notably the axios response interceptor, which runs outside any active
 * component instance and therefore cannot call `useToast()`/`useConfirm()`).
 *
 * `App.vue` renders the singletons (`<Toast/>` and the session-expired dialog) and
 * registers the toast callback once after mount. The interceptor only pushes here.
 */
import { reactive } from 'vue';

/** Bound to a root-level <Dialog>; set to true on 401 to prompt re-login. */
export const sessionExpired = reactive({visible: false});

type ToastFn = (msg: {severity: string; summary: string; detail?: string; life?: number}) => void;

let toastFn: ToastFn | null = null;

/** Called once from App.vue with `useToast().add`. */
export function registerToast(fn: ToastFn): void {
  toastFn = fn;
}

/** Shows a global error toast for unexpected, non-contextual failures (5xx, network). */
export function toastError(summary: string, detail?: string): void {
  toastFn?.({severity: 'error', summary, detail, life: 6000});
}